module.exports = __webpack_public_path__ + "static/media/driver@2.6c3f381c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/images/driver@2.jpg
// module id = 101
// module chunks = 0